export default __webpack_public_path__ + "static/double-profile-82c06544c01b4e108bb300cea4e40f5d.jpg";